export const getApiRoot = () => {
  return process.env.REACT_APP_API_ROOT
}
